module.exports = __webpack_public_path__ + "static/portfolio-12-29d356385cfb0b7390e742ce2d1ad76c.jpg";